import React, { FC, memo } from 'react';
import { BoxForListing, LockStatusMarker, useWatchLockState } from 'entities/Box';

interface BoxLockStatusProps {
  box: BoxForListing;
  warehouseId?: string;
}

export const BoxLockStatus: FC<BoxLockStatusProps> = memo((props) => {
  const { box, warehouseId } = props;

  const lockState = useWatchLockState(box, warehouseId);

  return <LockStatusMarker lockStatus={lockState} isExternalBox={box.timeToOpenLockMS != null} />;
});
